import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { deleteGalleryItem, getGallery } from '../../lib/api';

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const data = await getGallery();
      setGallery(data || []);
    } catch (error) {
      console.error('Error fetching gallery:', error);
      toast.error('Galeri yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu galeri öğesini silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      await deleteGalleryItem(id);
      setGallery((prev) => prev.filter((item) => item.id !== id));
      toast.success('Galeri öğesi başarıyla silindi');
    } catch (error) {
      console.error('Error deleting gallery item:', error);
      toast.error(error.message || 'Galeri öğesi silinirken bir hata oluştu');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#dbc582]"></div>
      </div>
    );
  }

  return (
    <div className="py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-semibold text-gray-900">Galeri</h1>
          <Link
            to="/admin/gallery/new"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#dbc582] hover:bg-[#c5b274] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#dbc582]"
          >
            Yeni Galeri Öğesi Ekle
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {gallery.map((item) => (
            <div key={item.id} className="relative bg-white rounded-lg shadow-md overflow-hidden">
              <div className="aspect-w-16 aspect-h-9">
                <img src={item.image_url} alt={item.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <div className="flex justify-between items-start gap-3">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900">{item.title}</h3>
                    <p className="mt-1 text-sm text-gray-500 line-clamp-2">{item.description}</p>
                  </div>
                  <span
                    className={`px-2 py-1 text-xs font-semibold rounded-full ${
                      item.type === 'product' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                    }`}
                  >
                    {item.type === 'product' ? 'Ürün' : 'Proje'}
                  </span>
                </div>
                <div className="mt-3">
                  <span
                    className={`px-2 py-1 text-xs rounded-full ${
                      item.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'
                    }`}
                  >
                    {item.is_active ? 'Aktif' : 'Pasif'}
                  </span>
                </div>
                <div className="mt-4 flex justify-end space-x-4">
                  <Link to={`/admin/gallery/${item.id}/edit`} className="text-[#dbc582] hover:text-[#c5b274]">
                    Düzenle
                  </Link>
                  <button onClick={() => handleDelete(item.id)} className="text-red-600 hover:text-red-900">
                    Sil
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
